<template>
  <div>
    <TimerControl @subcommand="subcommand"></TimerControl>

    <div class="c-controls">
      <div class="c-controls__group">
        <select v-model="team" @change="chooseTeam">
          <option v-for="team in teams" :key="team.uuid" :value="team.uuid">
            {{ team.name }}
          </option>
        </select>
      </div>
    </div>


  </div>
</template>

<script>
import BaseSlide from './BaseSlide';
import TimerControl from "../controls/TimerControl";

export default {
	name: 'SingleColorSinglePlanetSlide',
	mixins: [BaseSlide],
  data() {
    return {
      'team': this.$actions.getVariable('team'),
    };
  },
  methods: {
    chooseTeam(){
      this.$emit('subcommand', 'set-variable', {
        name: 'team',
        value: this.team
      })
    },
  },
  computed: {
	  teams(){
	    return this.$actions.getTeams();
    }
  },
  components: {
	  TimerControl
  },
};
</script>

<style></style>
